/**
 * `AW48` · El **contador a la vista** de `R1-F2 §5.6`, en un solo lugar.
 *
 * *«Tope de 4.096 caracteres, **con contador a la vista**, solo en los textos que
 * se le envían al participante.»*
 *
 * Está acá y no copiado en cada sección porque son diez campos con el mismo
 * contador, y dos copias del mismo cálculo divergen sin que nada se ponga rojo —
 * que es justamente el modo de falla que este contador existe para evitar del
 * lado del texto.
 *
 * ⚠️ **Cuenta puntos de código, no unidades UTF-16.** Ver `largo()` en
 * `reglas.ts`: `String.length` cuenta un emoji como dos, y el contador diría que
 * un mensaje se pasó cuando no se pasó.
 */

import type { JSX } from "react"
import { TOPE_AL_PARTICIPANTE } from "./borde-configuracion.ts"
import { largo } from "./reglas.ts"

/** El contador de un texto que un participante LEE: lleva el tope de la plataforma. */
export function Contador({ texto }: { readonly texto: string }): JSX.Element {
  const usado = largo(texto)
  const pasado = usado > TOPE_AL_PARTICIPANTE
  return (
    <span
      className={
        pasado
          ? "configuracion-chatbot__contador configuracion-chatbot__contador--pasado"
          : "configuracion-chatbot__contador"
      }
    >
      {usado} / {TOPE_AL_PARTICIPANTE}
    </span>
  )
}

/**
 * El contador del **perfil de personalidad**, que **no lleva el tope de la
 * plataforma de mensajería**.
 *
 * `§5.6`: *«nunca se envía como mensaje: se le manda al modelo como prompt del
 * sistema. Lleva un tope propio y mayor, fundado en el presupuesto de tokens del
 * turno.»* ⚠️ **Ese valor está pendiente del TL** (`§12`), así que acá **no hay
 * ningún número contra el cual comparar**: se cuenta y no se bloquea, y el caso
 * `R1-F2-09` —un perfil de más de 4.096 caracteres— es POSITIVO.
 *
 * ⛔ Inventar un número acá sería la fuente que después nadie discute.
 */
export function ContadorSinTope({ texto }: { readonly texto: string }): JSX.Element {
  return (
    <span className="configuracion-chatbot__contador">
      {largo(texto)} caracteres · sin tope definido todavía
    </span>
  )
}
